import { ListItemButton, styled } from "@mui/material";

export const CockpitListItemButton = styled(ListItemButton)({
  height: 49,
});

export const SlimListItemButton = styled(ListItemButton)({
  height: 20.8,
});
